import { useEffect } from "react";
import { CalendarCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n";

const IMG = "/garage.jpg";

export default function OverOns() {
  const { t } = useLang();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="container-x py-14" data-testid="over-ons-page">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="overline-red">Milano Worx</p>
          <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-white">{t("over.title")}</h1>
          <p className="mt-6 text-zinc-300 leading-relaxed">{t("over.p1")}</p>
          <p className="mt-4 text-zinc-400 leading-relaxed">{t("over.p2")}</p>
          <p className="mt-4 text-zinc-400 leading-relaxed">{t("over.p3")}</p>
          <Link to="/afspraak" className="btn-red mt-8" data-testid="about-cta">
            <CalendarCheck size={18} />{t("appt.title")}
          </Link>
        </div>
        <div className="rounded-2xl overflow-hidden border border-zinc-800">
          <img src={IMG} alt="Milano Worx werkplaats" className="w-full h-[420px] object-cover" />
        </div>
      </div>
    </div>
  );
}
